function nextTick(cb) {
  const nextTick2 = setTimeout(cb, 0);
  return function() {
    clearTimeout(nextTick2);
  };
}
export {
  nextTick
};
//# sourceMappingURL=nextTick.js.map
